// Vault buy box: plan toggle, gallery, and live price for variant + selling
// plan changes (works with the built-in toggle and subscription app widgets
// like Seal Subscriptions that inject a `selling_plan` input). Deferred.
(function () {
  function periodSuffix(title) {
    var t = (title || '').toLowerCase();
    if (/year|annual|yr|12\s*month/.test(t)) return '/year';
    if (/month|monthly|\bmo\b/.test(t)) return '/mo';
    if (/early/.test(t)) return '/year';
    if (/week/.test(t)) return '/wk';
    return '';
  }
  // Which billing period a title/plan name describes ('year' | 'month' | 'week' | '').
  function periodOf(text) {
    var t = (text || '').toLowerCase();
    if (/year|annual|yr|12\s*month|early/.test(t)) return 'year';
    if (/month|monthly|\bmo\b/.test(t)) return 'month';
    if (/week/.test(t)) return 'week';
    return '';
  }
  // Pick the selling plan that matches the variant's own period. Falls back to
  // the variant's first plan when nothing matches.
  function planIdForVariant(vd) {
    if (!vd || !vd.plans) return '';
    var ids = Object.keys(vd.plans);
    if (!ids.length) return '';
    var want = periodOf(vd.title);
    if (want && vd.planNames) {
      for (var i = 0; i < ids.length; i++) {
        if (periodOf(vd.planNames[ids[i]]) === want) return ids[i];
      }
    }
    return ids[0];
  }
  // Adverb for the selected plan, used to keep sentences like
  // "Auto-renews monthly" in step with the chosen plan.
  function periodWord(title) {
    var p = periodOf(title);
    if (p === 'year') return 'annually';
    if (p === 'month') return 'monthly';
    if (p === 'week') return 'weekly';
    return '';
  }
  // "Billed annually / monthly / weekly" from the plan title. Returns null when
  // the title has no period keyword, so a custom merchant note is left alone.
  function billingText(title) {
    var t = (title || '').toLowerCase();
    if (/year|annual|yr|12\s*month|early/.test(t)) return 'Billed annually';
    if (/month|monthly|\bmo\b/.test(t)) return 'Billed monthly';
    if (/week/.test(t)) return 'Billed weekly';
    return null;
  }

  document.querySelectorAll('.mm-bb').forEach(function (root) {
    var form = root.querySelector('.mm-bb__form') || root;
    var input = root.querySelector('[data-variant-input]');
    var priceEl = root.querySelector('[data-price]');
    var periodEl = root.querySelector('[data-period]');
    var ctaPriceEls = root.querySelectorAll('[data-cta-price]');
    var ctaSuffixEls = root.querySelectorAll('[data-cta-suffix]');

    var data = {};
    var dataEl = root.querySelector('[data-vault-prices]');
    if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) {} }

    function currentVariantId() {
      var idEl = form.querySelector('[name="id"]') || input;
      return idEl ? idEl.value : '';
    }
    function currentPlanId() {
      var checked = form.querySelector('[name="selling_plan"]:checked');
      if (checked) return checked.value;
      var hidden = form.querySelector('[name="selling_plan"]');
      return hidden ? hidden.value : '';
    }

    var obs = null;
    function set(el, text) { if (el && el.textContent !== text) el.textContent = text; }

    var annualSaveEl = root.querySelector('[data-annual-save]');
    var billingEl = root.querySelector('[data-billing]');
    var planDetailEl = root.querySelector('[data-plan-detail]');

    function update() {
      // Show the "Save X%" badge beside the price only while the annual/early
      // plan is the selected one.
      if (annualSaveEl) {
        annualSaveEl.hidden = String(currentVariantId()) !== annualSaveEl.getAttribute('data-annual-id');
      }
      var v = data[currentVariantId()];
      if (!v) return;
      var sp = currentPlanId();
      // Only trust the selling-plan price when that plan belongs to the
      // selected variant AND bills on the same period as it. Otherwise show
      // the variant's own price - a stale plan id from the previously
      // selected variant must never mask the real variant price.
      var price = v.price;
      if (sp && v.plans && v.plans[sp]) {
        var vPeriod = periodOf(v.title);
        var pPeriod = v.planNames ? periodOf(v.planNames[sp]) : '';
        if (!vPeriod || !pPeriod || vPeriod === pPeriod) price = v.plans[sp];
      }
      var suffix = periodSuffix(v.title);
      // Flip the "Billed monthly / annually" line to match the chosen plan.
      if (billingEl) { var bt = billingText(v.title); if (bt) set(billingEl, bt); }
      // Swap the period word inside the plan-detail sentence ("Auto-renews
      // monthly" -> "annually"), preserving the merchant's capitalisation.
      if (planDetailEl) {
        var tpl = planDetailEl.getAttribute('data-tpl') || '';
        var word = periodWord(v.title);
        if (tpl && word) {
          set(planDetailEl, tpl.replace(/\b(monthly|annually|yearly|weekly)\b/gi, function (m) {
            return m.charAt(0) === m.charAt(0).toUpperCase()
              ? word.charAt(0).toUpperCase() + word.slice(1)
              : word;
          }));
        }
      }
      // Pause the observer while we write so our own DOM writes can never
      // re-trigger update() (that was the infinite-loop bug).
      if (obs) obs.disconnect();
      set(priceEl, price);
      ctaPriceEls.forEach(function (el) { set(el, price); });
      ctaSuffixEls.forEach(function (el) { set(el, suffix); });
      if (obs) obs.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    }

    // Built-in plan toggle (variants)
    root.querySelectorAll('.mm-bb__plan').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.mm-bb__plan').forEach(function (x) { x.classList.remove('is-on'); });
        btn.classList.add('is-on');
        if (input && btn.dataset.variantId) input.value = btn.dataset.variantId;
        if (periodEl && btn.dataset.variantPeriod) set(periodEl, btn.dataset.variantPeriod);
        // Keep the fallback selling-plan input pointing at a plan that belongs
        // to the newly selected variant (Monthly vs Annual have different ids)
        // AND whose billing period matches that variant - picking the wrong
        // allocation is what made an annual variant show a monthly-plan price.
        var fb = form.querySelector('[data-mm-plan-fallback]');
        if (fb && btn.dataset.variantId) {
          var vd = data[btn.dataset.variantId];
          var picked = planIdForVariant(vd);
          if (picked) fb.value = picked;
        }
        update();
      });
    });

    // React to any plan/variant change the app (or theme) makes
    form.addEventListener('change', update);
    obs = new MutationObserver(update);
    obs.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    // Subscription widgets inject async — re-sync shortly after load
    setTimeout(update, 400);
    setTimeout(update, 1500);
    update();

    // Gallery thumbnails
    var main = root.querySelector('.mm-bb__main-img');
    root.querySelectorAll('.mm-bb__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.mm-bb__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.dataset.img;
        if (main && main.tagName === 'IMG' && src) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
        }
      });
    });
  });
})();
